export default __webpack_public_path__ + "static/media/lodgify_step13.c2d26724.jpg";